import { render, staticRenderFns } from "./ModalConfigurationStatus.vue?vue&type=template&id=faab28d8&scoped=true&"
import script from "./ModalConfigurationStatus.vue?vue&type=script&lang=js&"
export * from "./ModalConfigurationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faab28d8",
  null
  
)

export default component.exports